import React from "react";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  text?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ text = "Retour" }) => {
  const navigate = useNavigate();

  return (
    <button
      className="btn btn-outline-secondary mb-3 d-flex align-items-center"
      onClick={() => navigate(-1)}
    >
      <i className="bi bi-arrow-left me-2"></i>
      {text}
    </button>
  );
};

export default BackButton;
